module.exports = __webpack_public_path__ + "4ec86ba2eb6b689101c97110d52136e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/profile/perfil/images/hat.png
// module id = 388
// module chunks = 0